

























import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'VButton',

  props: {
    element: {
      type: String,
      default: 'button'
    },
    to: {
      type: [String, Object],
      default: '#'
    },
    full: {
      type: Boolean,
      default: true
    },
    type: String,
    icon: String,
    iconRight: String
  }
})
